import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AvailableModals, closeModal } from '../modalSlice';
import { ReduxState, useAppDispatch } from '../../../store';
import { Modal } from 'antd';
import SkuDailyTransactionsChart from '../../Detail/sections/SkuDailyTransactionsChart/SkuDailyTransactionsChart';
import { useGetSkuQuery } from '../../Detail/apiDetail';
import { ReadOnlyItem, Row, Title } from '@ydistri/ds';
import ProductIdOrCode from '../../../components/global/ProductIdentifications/ProductIdentifications';
import StoreIdOrCode from '../../../components/global/StoreIdentifications/StoreIdentifications';
import { SKU_ID_LABEL } from '../../../components/global/_constants';
import { SystemIdMode } from '../../../components/global/Identifications/useIdentificationItems';

const modalId = AvailableModals.SKU_DAILY_SALES;

const SkuDailySalesModal: React.FC = () => {
  const dispatch = useAppDispatch();

  const open = useSelector((state: ReduxState) => state.modal.openedModal === modalId);
  const modalData = useSelector((state: ReduxState) => state.modal.modalData[modalId]);
  const skuId = modalData?.skuId ?? 0;

  const { data: sku, isFetching: isSkuFetching } = useGetSkuQuery(skuId);

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const title = useMemo(
    () =>
      isSkuFetching ? (
        'Loading...'
      ) : (
        <Row $gap="4rem">
          <Row $gap="1rem">
            <Title>Product: {sku?.product?.name}</Title>
            {sku?.product && (
              <ProductIdOrCode product={sku.product} systemIdMode={SystemIdMode.DIFFERENT_ONLY} />
            )}
          </Row>
          <Row $gap="1rem">
            <Title>Store: {sku?.store?.name}</Title>
            {sku?.store && (
              <StoreIdOrCode store={sku.store} systemIdMode={SystemIdMode.DIFFERENT_ONLY} />
            )}
          </Row>
          <ReadOnlyItem key="sku-id" label={SKU_ID_LABEL} value={skuId.toString()} />
        </Row>
      ),

    [isSkuFetching, sku, skuId],
  );

  if (!open) return null;
  return (
    <Modal title={title} centered open={true} width="80%" onCancel={handleClose} footer={null}>
      <SkuDailyTransactionsChart skuId={skuId} vat={sku?.vat} />
    </Modal>
  );
};

export default SkuDailySalesModal;
